import { ColorOptions, ModBox, RadioButtonGroup, required, Spacer, TextNew } from '@jfs/ui-new'
import { useCallback, useEffect } from 'react'
import { Dropdown } from '../../../../components/Dropdown'
import { RootStore, useLazyApiData, useStores } from '../../../../data/store'
import { MessageTypes } from '../../../../utils'
import { SearchParentEntity } from '../../../EntityManagement/Onboarding/CreateEntity/SearchParentEntity'
import { subGrpheaderData } from '../../../EntityManagement/Onboarding/CreateEntity/SelectParentEntityList/Fixtures'
import { styles } from './styles'

const hideParentSubGroup = (editable: boolean) => (values: any) => !values?.parentGroupName || !editable
const hideParentGroup = (editable: boolean) => (values: any) => values?.parentType !== 'SubGroup' || !editable
const hideParentEntity = (editable: boolean) => (values: any) => values?.parentType !== 'Entity' || !editable
const hideNonEditableView = (editable: boolean) => (values: any) => editable

export const selectParentEntityForm = (entityLovs: any[], editable: boolean) => ({
  key: 'PARENT_ENTITY_FORM',
  verticalFlex: 1,
  contentOverflow: 'auto',
  contentPadding: 24,
  horizontalFlex: 1,
  title: editable ? 'Select Parent to Link' : 'Selected Parent Entity ',
  formItems: [
    {
      fieldName: 'title',
      ComponentName: TextNew,
      title: 'Parent Type :',
      fontSize: 12,
      color: 'PRIMARY_GREY' as ColorOptions,
      lineHeight: 18,
      fontFamily: 'jiotype-medium',
    },
    {
      fieldName: 'nonEditableParentDetails',
      ComponentName: NonEditableParentDetailsWraper,
      hideComponent: hideNonEditableView(editable),
      validationSchema: required,
      editable,
    },
    {
      fieldName: 'parentType',
      ComponentName: ParentTypeRadioButton,
      editable,
      data: ['SubGroup', 'Entity'],
      textSize: 12,
      size: 14,
      textPadding: 0,
      minItemHeight: 36,
      textColor: 'PRIMARY_GREY',
      horizontalGap: 20,
      color: 'BLUE_SHADE_PRIMARY',
      direction: 'horizontal',
      hide: !editable,
      validationSchema: required,
    },
    {
      horizontalComps: [
        {
          fieldName: 'parentGroup',
          ComponentName: SelectParentGroup,
          validationSchema: required,
          hideComponent: hideParentGroup(editable),
          show: editable,
          ...styles.dropDownStyle(editable),
        },
      ],
    },
    {
      horizontalComps: [
        {
          fieldName: 'parentSubGroup',
          ComponentName: SelectParentSubgroup,
          hideComponent: hideParentSubGroup(editable),
          validationSchema: required,
          show: editable,
          ...styles.dropDownStyle(editable),
        },
      ],
    },
    {
      fieldName: 'parentEntity',
      ComponentName: SearchParentEntityWrapper,
      title: 'Parent Type :',
      showRadioButtons: false,
      placeholder: 'Search parent by Entity ID…',
      hideComponent: hideParentEntity(editable),
      searchTitle: '',
      showSearch: true,
      show: editable,
      validationSchema: required,
      /*   getSelectedData={getParentBySelectedData}

      onSearchPress={onSearchParentByPress}
      selectedRadioBtn={parentTypeSelected}
      isSearchLoading={masMid === '' && fetchSearchHandler?.state === 'pending'}
      onClearPressed={onSearchParentClearPressed}
      searchValue={parentEntitySearchId}*/
    },
  ],
  onSubmit: async (values) => {},
})

const SelectParentGroup = (props: any) => {
  const { fetchGroupsList, groupsList } = useStores((store) => ({
    fetchGroupsList: store.getGroupsList,
    groupsList: store.onboarding.getGroupsList(),
  }))

  const [fetchGroups, fetchGroupsListHandler] = useLazyApiData(fetchGroupsList)

  useEffect(() => {
    if (!groupsList?.length) {
      fetchGroups('')
    }
    props?.setFieldValue(props?.fieldName, props.allValues.parentGroupName)
  }, [])

  useEffect(() => {
    if (
      fetchGroupsListHandler?.state === 'fulfilled' &&
      props?.allValues?.parentGroupId &&
      !props?.allValues?.parentGroup
    ) {
      props?.setFieldValue(
        props?.fieldName,
        groupsList.find((item) => item?.groupId === props?.allValues?.parentGroupId)?.brandName ?? '',
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchGroupsListHandler?.state])

  const onParentGrpRowPress = useCallback(
    (item: any) => {
      props?.setFieldValue('parentGroupName', item?.brandName)
      props?.setFieldValue('parentGroupId', item?.groupId)
      props?.setFieldValue('parentSubGroupId', undefined)
      props?.setFieldValue('parentSubGroup', undefined)
      props?.setFieldValue('parentSubGroupName', undefined)
      props?.setFieldValue(props?.fieldName, item?.brandName)
    },
    [props],
  )

  return (
    <ModBox show={props?.show}>
      <Dropdown
        {...props}
        error={props.allValues.parentGroupName ? undefined : props.error}
        value={props.allValues.parentGroupName}
        type="table"
        label={'Parent Group'}
        title={'Select Parent Group'}
        onTableItemPress={onParentGrpRowPress}
        tableData={groupsList ?? []}
        data={[]}
        tableColumnMapper={flexMapperWithIndex}
        tableHeaderTitles={headerData}
        chevronColor={'PRIMARY'}
        isDataLoading={fetchGroupsListHandler?.state === 'pending'}
      />
    </ModBox>
  )
}

const flexMapperWithIndex: any = {
  0: 1,
  1: 1,
}

const headerData = [
  {
    title: 'Group Id',
  },
  {
    title: 'Group Name',
  },
]

const SelectParentSubgroup = (props: any) => {
  const { fetchSubGroupsList } = useStores((store) => ({
    fetchSubGroupsList: store.getSubGroupsList,
  }))

  const [fetchSubGroups, fetchSubGroupsListHandler] = useLazyApiData(fetchSubGroupsList)
  useEffect(() => {
    props?.setFieldValue(props?.fieldName, props.allValues.parentSubGroupName)
  }, [])
  useEffect(
    () => fetchSubGroups(props?.allValues?.parentGroupId, ''),
    [fetchSubGroups, props?.allValues?.parentGroupId],
  )

  useEffect(() => {
    if (
      fetchSubGroupsListHandler?.state === 'fulfilled' &&
      props?.allValues?.parentSubGroupId &&
      !props?.allValues?.parentSubGroup
    ) {
      props?.setFieldValue(
        props?.fieldName,
        fetchSubGroupsListHandler.data.find((item) => item?.identificationNumber === props?.allValues?.parentSubGroupId)
          ?.brandName ?? '',
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchSubGroupsListHandler])

  const onParentSubGrpRowPress = useCallback(
    (item: any) => {
      console.log('item=', item?.brandName)
      console.log('props=', props?.fieldName)
      props?.setFieldValue('parentSubGroupName', item?.brandName)
      props?.setFieldValue('parentSubGroupId', item?.identificationNumber)
      props?.setFieldValue(props?.fieldName, item?.brandName)
    },
    [props],
  )

  return (
    <ModBox show={props?.show}>
      <Dropdown
        {...props}
        value={props.allValues.parentSubGroupName}
        type="table"
        label={'Parent SubGroup'}
        title={'Select Parent Sub Group'}
        onTableItemPress={onParentSubGrpRowPress}
        tableData={fetchSubGroupsListHandler.data ?? []}
        error={props.value ? undefined : props.error}
        data={[]}
        tableColumnMapper={flexMapperWithIndex}
        tableHeaderTitles={subGrpheaderData}
        chevronColor={'PRIMARY'}
        isDataLoading={fetchSubGroupsListHandler?.state === 'pending'}
      />
    </ModBox>
  )
}

const SearchParentEntityWrapper = (props: any) => {
  const { fetchSearchEntity } = useStores((store) => ({
    fetchSearchEntity: store.fetchSearchEntity,
  }))
  useEffect(() => {
    props?.setFieldValue(props?.fieldName, props.allValues.parentEntityId)
  }, [])
  const [fetchSearch, fetchSearchHandler] = useLazyApiData(fetchSearchEntity)

  console.log('fetchSearchHandler=', fetchSearchHandler)

  const onSearchParentByPress = useCallback(
    (entityId) => {
      if (/^\d+$/.test(entityId)) {
        fetchSearch(entityId, 'Entity ID', 'ALL')
      } else {
        RootStore.message.setMessage('Invalid Id, Please enter numeric value', MessageTypes.ERROR)
      }
    },
    [fetchSearch],
  )

  useEffect(() => {
    if (fetchSearchHandler?.state === 'fulfilled') {
      const entityId = fetchSearchHandler?.data?.findEntity?.entitySearchList?.[0]?.identificationNumber
      props?.setFieldValue('parentEntityId', entityId)
      props?.setFieldValue(props?.fieldName, entityId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchSearchHandler?.state])

  return (
    <ModBox show={props?.show}>
      <SearchParentEntity
        onSearchPress={onSearchParentByPress}
        value={props.allValues.parentEntityId}
        isSearchLoading={fetchSearchHandler?.state === 'pending'}
        onClearPressed={() => {
          props?.setFieldValue('parentEntityId', '')
          props?.setFieldValue(props?.fieldName, '')
        }}
        {...{
          title: 'Parent Type :',
          showRadioButtons: false,
          placeholder: 'Search parent by Entity ID…',
          dependency: ['parentType', 'Entity'],
          hideComponent: false,
          searchTitle: '',
          showSearch: true,
        }}
      />
    </ModBox>
  )
}

const NonEditableParentDetailsWraper = ({
  allValues: { parentType = 'NA', parentGroupId = 'NA', parentSubGroupId = 'NA', parentEntityId = 'NA' },
  editable,
}: any) => {
  console.log('parentSubGroup', parentSubGroupId)

  return (
    <ModBox show={!editable}>
      <TextNew {...styles.detailsText} title={parentType} />
      {parentType !== 'Entity' && (
        <>
          <Spacer size={16} />
          <TextNew {...styles.titleText} title={'Parent Group: '} />
          <Spacer size={8} />
          <TextNew {...styles.detailsText} title={parentGroupId} />
          <Spacer size={16} />
          <TextNew {...styles.titleText} title={'Parent Sub Group: '} />
          <Spacer size={8} />
          <TextNew {...styles.detailsText} title={!parentSubGroupId ? 'NA' : parentSubGroupId} />
          <Spacer size={8} />
        </>
      )}

      {parentType === 'Entity' && (
        <>
          <Spacer size={16} />
          <TextNew {...styles.titleText} title={'Parent Entity Id: '} />
          <Spacer size={8} />
          <TextNew {...styles.detailsText} title={parentEntityId} />
        </>
      )}
    </ModBox>
  )
}

const ParentTypeRadioButton = (props) => {
  const onChange = (item) => {
    if (item !== props?.allValues?.parentType) {
      props?.setFieldValue('parentGroupName', undefined)
      props?.setFieldValue('parentGroup', undefined)
      props?.setFieldValue('parentGroupId', undefined)
      props?.setFieldValue('parentSubGroupId', undefined)
      props?.setFieldValue('parentSubGroupName', undefined)
      props?.setFieldValue('parentSubGroup', undefined)
      props?.setFieldValue('parentEntityId', undefined)
      props.onChange(item)
    }
  }
  return <RadioButtonGroup callOnChangeOnLoad={false} {...props} onChange={onChange} />
}
